import { LoggedInfo, ProfileDropdown } from 'legacy-components/componets';
import { ILoggedInInfoProps } from './logged- info/logged- info';
import { AuthRole } from 'common/enums/enums';

export type ProfileInfoProps = {
  profile: ILoggedInInfoProps;
  activeRole?: AuthRole;
};

export const ProfileInfo = ({ profile, activeRole }: ProfileInfoProps) => {
  return (
    <ProfileDropdown activeRole={activeRole}>
      <LoggedInfo {...profile} />
    </ProfileDropdown>
  );
};
